import React from "react";
import {RadioGroup} from "@mui/material";
import {StyledFormHelperText} from "./RadioInput.styles";

interface RadioGroupProps {
    name: string;
    value: any;
    defaultValue?: string | number;
    errorMessage?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    children: React.ReactNode;
}

export const RadioInputGroup = ({name, value, defaultValue, onChange, children, errorMessage, ...props}: RadioGroupProps) => {
    return (
        <>
            <RadioGroup
                {...props}
                name={name}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
            >
                {children}
            </RadioGroup>
            {errorMessage ? <StyledFormHelperText>{errorMessage}</StyledFormHelperText> : null}
        </>
    );
}